export default /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-journey/node_modules/uuid/dist/esm-browser/regex.js
// module id = 2277
// module chunks = 0